import { useEffect, useRef, useState } from 'react'
import './App.css'
import useCaseInsensitiveSearchParams from './useCaseInsensitiveSearchParams'
import OrganizationYearWeekPage from './OrganizationYearWeekPage'
import Consts from './Const'

interface IOrganizationYearWeekPageProps {
  organizationId?: string
}

interface IOrganizationActivityRelation {
  Id: string
  OrganizationId: string
  ActivityType: number
  IsDefault: boolean
}

function OrganizationYearWeekPageSwitcher({ organizationId }: IOrganizationYearWeekPageProps) {
  const searchParams = useCaseInsensitiveSearchParams()

  //organizationId = organizationId ?? searchParams['organizationid'] ?? '8c0193a8-bb41-4623-8199-5c8a3ecd3088' // Keylane
  const [activityTypes, setActivityTypes] = useState<number[]>(() => (searchParams['activitytypes'] ?? '0').split(', ').map(x => +x))

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetch(`${Consts.defaultBaseUrl}/activity/organizationRelations/${organizationId}`)

        if (response.ok) {
          const organizationActivityRelations = (await response.json()) as IOrganizationActivityRelation[]

          console.log(
            `organizationActivityRelations.map(x => x.ActivityType)`,
            organizationActivityRelations.map(x => x.ActivityType),
          )
          const newActivityTypes = organizationActivityRelations.map(x => x.ActivityType)
          setActivityTypes(newActivityTypes)
          if (newActivityTypes.length > 0) {
            setCurrentActivityType(newActivityTypes[0])
          }
        } else {
          setActivityTypes([])
        }
      } catch {
        setActivityTypes([])
      }
    }

    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Consts.defaultBaseUrl, organizationId])

  //https://ranky.woohooo.dk/activity/organizationRelations/8c0193a8-bb41-4623-8199-5c8a3ecd3088

  const [currentActivityType, setCurrentActivityType] = useState(activityTypes[0])
  const gotoNextActivityType = () => {
    setCurrentActivityType(e => {
      const existingIndex = activityTypes!.findIndex(x => x === e)
      const newIndex = existingIndex === activityTypes!.length - 1 ? 0 : existingIndex + 1
      return activityTypes![newIndex]
    })
  }

  const DURATION = 1000
  const COUNTDOWNSTEPS = 15 // aka interval of COUNTDOWNSTEPS * 1000ms

  const checkIfDurationMustBeIncreased = (activityType: number, animDuration: number) => {
    animDuration = animDuration * 1.3 // 30 percentage because.. well, why not
    if (currentActivityType === activityType && animDuration > DURATION * COUNTDOWNSTEPS) {
      var newCountDown = Math.ceil(animDuration / DURATION)
      countDownRef.current = newCountDown
      setCountDown(newCountDown)
    }
  }

  const countDownRef = useRef(COUNTDOWNSTEPS)
  const [countdown, setCountDown] = useState(COUNTDOWNSTEPS)

  useEffect(() => {
    if (activityTypes!.length < 2) return

    const id = window.setInterval(() => {
      if (countDownRef.current === 1) {
        countDownRef.current = COUNTDOWNSTEPS
        setCountDown(COUNTDOWNSTEPS)
        gotoNextActivityType() // <-- skift direkte, CSS fader
      } else {
        countDownRef.current--
        setCountDown(x => x - 1)
      }
    }, 1000)

    return () => window.clearInterval(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityTypes])

  const layerStyle: React.CSSProperties = {
    position: 'absolute',
    inset: 0,
    transition: `opacity ${DURATION}ms ease`,
    willChange: 'opacity',
  }

  return (
    <>
      {activityTypes.map(activityType => (
        <div
          key={`activity${activityType}`}
          style={{
            ...layerStyle,
            opacity: currentActivityType === activityType ? 1 : 0,
            pointerEvents: currentActivityType === activityType ? 'auto' : 'none',
          }}
        >
          <OrganizationYearWeekPage
            activityType={activityType}
            shown={currentActivityType === activityType}
            organizationId={organizationId}
            showActivityTypeName={activityTypes!.length > 1}
            countdown={countdown}
            onSetAnimDuration={duration => {
              checkIfDurationMustBeIncreased(activityType, duration)
            }}
          />
        </div>
      ))}
    </>
  )
}

export default OrganizationYearWeekPageSwitcher
